<template>
  <header>
    <div id="header" class="home_header">
      <div id="head_text">
        <div class="wrapper">
          <div class="header_text">
            <UiAnim tag="h1" type="rl-100"> Тюнинг оптики и ремонт фар </UiAnim>

            <UiAnim tag="p" type="rl-100" class="sl" delay="1">
              Сделаем свет фар вашего автомобиля <span>идеальным</span>!
            </UiAnim>
            <UiAnim tag="p" type="rl-100" class="sl" delay="2">
              Эксклюзивный тюнинг, безопасная езда...
            </UiAnim>

            <UiAnim tag="h2" type="rl-100" class="cn" delay="3">
              В центре авторестайлинга BGTworkshop
            </UiAnim>

            <UiAnim type="rl-100" delay="4">
              <UiZakazBtn />
            </UiAnim>
          </div>
        </div>
      </div>
      <ClientOnly>
        <HomeParticles />
      </ClientOnly>
    </div>
  </header>
</template>